import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toRef } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'pagination',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["pageChange", "pageSizeChange"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const page = toRef(props.config, 'page');
    const size = toRef(props.config, 'size');
    const total = toRef(props.config, 'total');
    function onSizeChange(val) {
      emits('pageSizeChange', val);
    }
    function onPageChange(val) {
      emits('pageChange', val);
    }
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createBlock(_component_el_pagination, {
        "current-page": page.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => page.value = $event),
        "page-size": size.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => size.value = $event),
        "page-sizes": __props.config.sizes || [20, 50, 100],
        small: true,
        background: true,
        layout: props.config.layout || 'total, sizes, prev, pager, next, jumper',
        total: total.value,
        onSizeChange: onSizeChange,
        onCurrentChange: onPageChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "layout", "total"]);
    };
  }
});